// src/components/AuthControls.js
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { setCredentials } from "../../../state/authSlice";
import { trackUIEvent } from "../../../utils/analytics";
import "./styles.css";

export default function AuthControls() {
  const {
    loginWithPopup,
    logout,
    isAuthenticated,
    user,
    isLoading,
    getAccessTokenSilently,
  } = useAuth0();

  const dispatch = useDispatch();

  const audience = process.env.REACT_APP_AUDIENCE; // ✅ must match your API identifier

  const handleLogin = async () => {
    try {
      await loginWithPopup({
        authorizationParams: {
          audience: process.env.REACT_APP_AUDIENCE,
        },
      });
      trackUIEvent("Auth", "Login via popup");
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const handleLogout = () => logout({ localOnly: true });

  useEffect(() => {
    let mounted = true;
    const stashToken = async () => {
      try {
        if (isAuthenticated) {
          const token = await getAccessTokenSilently({
            authorizationParams: { audience },
          });
          dispatch(setCredentials({ user, token }));
          if (mounted) localStorage.setItem("api_token", token);
        } else {
          localStorage.removeItem("api_token");
        }
      } catch (err) {
        console.error("Token fetch failed:", err);
      }
    };
    stashToken();
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, getAccessTokenSilently]);

  if (isLoading) return null;

  return (
    <div className="auth-controls">
      {!isAuthenticated ? (
        <div className="auth-buttons">
          <button className="add-pointer" onClick={handleLogin}>
            Login
          </button>
        </div>
      ) : (
        <div className="auth-logged-in">
          <span>
            <img className="profile-icon" src="/profile.png" alt="Profile" />
          </span>
          <button className="add-pointer" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
